import { useMemo } from 'react';
import { gqlGenderIdentityEnum as GENDER_IDENTITY } from '@minecraft.graphql-types';
import { useTranslation } from '@blocs.i18n';

export const useGenderIdentityOptions = () => {
  const { t } = useTranslation();

  return useMemo(
    () => [
      { value: GENDER_IDENTITY.TRANS, label: t('common:label.gender.trans') },
      { value: GENDER_IDENTITY.NON_BINARY, label: t('common:label.gender.nonBinary') },
    ],
    [t]
  );
};
